__turbopack_export_value__({
  "className": "montserrat_400610d1-module__RLdfwq__className",
});
